// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1890FF"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/element-variables.scss
// module id = YWLt
// module chunks = 182